import { apiClient } from '@/lib/api/client';

export interface SearchResult {
  id: string;
  title: string;
  type: 'run' | 'suite' | 'test';
  path: string;
  description?: string;
  metadata?: Record<string, unknown>;
}

export interface SearchResponse {
  results: SearchResult[];
  total: number;
}

export const searchApi = {
  search: async (query: string, type?: 'run' | 'suite' | 'test', limit: number = 10): Promise<SearchResponse> => {
    // Build query parameters
    const params: Record<string, string> = {
      q: query,
      limit: limit.toString()
    };
    
    if (type) {
      params.type = type;
    }
    
    // Make the API call
    const response = await apiClient.get('/api/search', { params });
    
    // Handle response
    if (response.success && response.data) {
      if (typeof response.data === 'object' && 'results' in response.data) {
        const searchResponse = response.data as SearchResponse;
        
        // Ensure all results have required properties
        const sanitizedResults = searchResponse.results.map(result => ({
          ...result,
          title: result.title || 'Untitled',
          type: result.type || 'test',
          path: result.path || '',
          id: result.id || `search-${Date.now()}-${Math.random()}`
        }));
        
        return {
          results: sanitizedResults,
          total: searchResponse.total || sanitizedResults.length
        };
      }
    }
    
    // Return empty results if response format is unexpected
    return {
      results: [],
      total: 0
    };
  }
}; 